export const MANAGE_FIELDS_EV_ID = 'manage-fields-clicked';
